//import React from 'react';
import '../styles/header.css';
import brands from '../brands.json';

const Header = () => {
    
    const logoPath = `/images/${brands[process.env.REACT_APP_BRAND].logo}`;
    const homePage = `https://${brands[process.env.REACT_APP_BRAND].homePage}`;
    console.log(homePage)
    return (
        <div className="header">
            <div className="header-logo">
               <a href={homePage}><img src={logoPath} alt="Logo" /></a>
            </div>
            <div className="banner">

            </div>
        </div>
    );
}

export default Header;
